<template>
  <svg 
    :width="width" 
    :height="height"
    :viewBox="viewBox"
    fill="none" xmlns="http://www.w3.org/2000/svg"
  >
  <path d="M24 48.3335c-13.1158 0-23.74988-10.673-23.75-23.8408C.25 11.3247 10.8841.65186 24 .65186S47.75 11.3248 47.75 24.4927C47.7499 37.6605 37.1158 48.3335 24 48.3335Z" fill="#fff" stroke="#E61E57" stroke-width=".5"/>
  <mask id="a" fill="#fff">
    <path d="M24 48.5835c-6.3652 0-12.4697-2.5382-16.97056-7.0561C2.52857 37.0095 0 30.8818 0 24.4925c0-6.3894 2.52856-12.517 7.02943-17.03495C11.5303 2.93961 17.6348.40145 24 .40145V48.5835Z"/>
  </mask>
  <path d="M24 48.5835c-6.3652 0-12.4697-2.5382-16.97056-7.0561C2.52857 37.0095 0 30.8818 0 24.4925c0-6.3894 2.52856-12.517 7.02943-17.03495C11.5303 2.93961 17.6348.40145 24 .40145V48.5835Z" fill="#E61E57" stroke="#E61E57" stroke-width="1.5" mask="url(#a)"/>
  <circle cx="6.53366" cy="30.4585" r="2.03366" fill="#fff"/>
  <path d="M16.5225 22.5034H8.20844c-.98692 0-3.70844.9427-3.70844 3.9932h8.3141c1.0766 0 3.6486-.9727 3.7084-3.9932ZM20.5303 16.4922H8.20869c-.98693 0-3.70845.9426-3.70845 3.9932H16.7919c1.0767 0 3.6786-.9727 3.7384-3.9932Z" fill="#fff"/>
  <path d="m43.1472 20.9113-15.2468 7.7731-.1035-1.4591.9776-.5005c.0002-.0001.0018-.0009.0047-.0024l14.3192-7.3313.0488 1.5202Z" fill="#E61E57"/>
  <path d="M35.4658 18.8638c1.4481 0 2.7946.5272 3.8735 1.33l-1.2912.6504c-.7671-.4463-1.6321-.6504-2.5823-.6504-2.8788 0-5.2221 2.2344-5.2221 5.1264v.6524l-1.4645.7497c.0412-.0224.3317-.2222.2307-1.3542 0-3.5787 2.8772-6.5043 6.4559-6.5043ZM27.8062 29.8797l15.2469-7.7731.1035 1.4591-.9777.5005a.1904.1904 0 0 0-.0046.0024l-14.3192 7.3313-.0489-1.5202ZM35.4877 31.9272c-1.4482 0-2.7946-.5272-3.8736-1.33l1.2912-.6504c.7672.4463 1.6321.6504 2.5824.6504 2.8788 0 5.2221-2.2344 5.2221-5.1264v-.6523l1.4644-.7498c-.0412.0225-.3317.2223-.2307 1.3542 0 3.5787-2.8771 6.5043-6.4558 6.5043Z" fill="#E61E57"/>
</svg>
</template>
<script setup>
  const props = defineProps({
    constant: {
      type: Object,
      default: () => {}
    },
    width: {
      type: Number,
      default: 0
    },
    height: {
      type: Number,
      default: 0
    },
    size: {
      type: Number,
      default: 0
    },
  })

  const viewBox = `0 0 48 49`
  const width = props.width * props.size
  const height = props.height * props.size
</script>